import { Alert, Stack, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import { green } from "@mui/material/colors";
import BuildIcon from "@mui/icons-material/Build";

const StyledAlert = styled(Alert)(({theme})=>({
    backgroundColor:green[700],
    color:theme.palette.success.contrastText,
    paddingTop:0,
    paddingBottom:0
}))

export default function DevVersion(){
    const mode = import.meta.env.VITE_APP_ENV;
    const version = import.meta.env.VITE_APP_VERSION;

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    function getModeLabel(val:string) {
        if(smallScreen) return val.charAt(0).toUpperCase();
        return val.charAt(0).toUpperCase() + val.slice(1);
    }

    if (!mode) return null;

    return <StyledAlert icon={false}>
        <Stack direction="row" alignItems="center" gap={0.5}>
            <BuildIcon sx={{ fontSize: { xs: 12, sm: 14 }, color: "inherit", opacity: 0.85 }} />
            <Typography variant="subtitle2" fontSize={{xs:"0.6rem", sm:"0.8rem"}}>{getModeLabel(mode)}&nbsp;v{version}</Typography>
        </Stack>
    </StyledAlert>
}